import React from "react";
import CompanyUsersTable from "./CompanyUsersTable";

const CompanyUsers = () => {
  return (
    <div>
      <CompanyUsersTable />
    </div>
  );
};

export default CompanyUsers;
